// TODO: add missing types
// import { Person } from '@clubspark-node/clubspark-tennis-types';
import {
  type Contact,
  type DrawDefinition,
  type Entry,
  type Event,
  type Participant,
  type Penalty,
  type Side,
} from '@clubspark-node/clubspark-tennis-types';

import { type Category } from 'typedefs/event';

export type { Contact, Event };

export type ParticipantId = string;

export interface SuspensionPoint {
  comment: string | null;
  code: string;
  shortDescription: string;
  longDescription: string;
  points: number;
}

export enum PenaltyAction {
  ADD = 'addPenalty',
  UPDATE = 'modifyPenalty',
  DELETE = 'removePenalty',
}

export enum PenaltyExtensionNames {
  POINTS = 'points',
  SHORT_DESCRIPTION = 'shortDescription',
  LONG_DESCRIPTION = 'longDescription',
}

export interface PenaltyInterface extends Omit<Penalty, 'createdAt'> {
  penaltyAction?: PenaltyAction;
  createdAt: string;
}

export interface ParticipantInterface extends Participant {
  events?: (Event & { tournamentId: string } & Omit<Entry, 'participantId'>)[] | undefined;
  individualParticipants?: Participant[] | undefined;
  signedIn?: boolean | string | undefined;
  seedings?: Record<'SINGLES' | 'DOUBLES', Array<{ scaleDate: string; scaleName: string; scaleValue: string }>>;
}

export type EventInterface = Event & { tournamentId: string; tournamentCategory?: Category };

export interface EventParticipant extends ParticipantInterface {
  drawPosition?: number;
  entryPosition?: number;
}

export type ParticipantPairArray = {
  pair: [ParticipantInterface, ParticipantInterface];
  participantId: string;
}[];

export interface Substitution {
  participantId: string;
  previousParticipantId: string;
  substitutionOrder: number;
}
export interface SideInterface extends Side {
  participant: ParticipantInterface;
  participantId: string;
  seedNumber?: number;
  seedValue?: number;
  sideNumber: number;
  displaySideNumber?: number;
  drawPosition: number;
  sourceDrawPositionRange: string;
  bye?: boolean;
  qualifier?: boolean;
  participantAdvanced?: boolean;
  participantFed?: boolean;
  teamParticipant?: ParticipantInterface;
  substitutions?: Substitution[];
}

export interface SeedAssignment {
  seedNumber?: number;
  seedValue?: string;
  participantId?: string;
}

export interface FlightProfile {
  flightNumber: number;
  flights?: any[];
  drawId: string;
  drawName: string;
  drawEntries?: Entry[];
  drawSize?: number;
  drawDefinition?: DrawDefinition;
  manuallyAdded?: boolean;
}

export interface UserAdminOrSuperAdmin {
  isUserAdminWithTournamentScope: boolean;
}

export interface ScaleItem {
  eventType: string;
  scaleName: string;
  scaleValue: any;
}
